import { render, staticRenderFns } from "./DatasetsList.vue?vue&type=template&id=4403c9a5&scoped=true&"
import script from "./DatasetsList.vue?vue&type=script&lang=js&"
export * from "./DatasetsList.vue?vue&type=script&lang=js&"
import style0 from "./DatasetsList.vue?vue&type=style&index=0&id=4403c9a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4403c9a5",
  null
  
)

export default component.exports